import { Card, Box, CardMedia, IconButton } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DialogService from "../Dialog/dialogService";
import ImageDetail from "../ImageDetail/ImageDetail";

interface ImageViewProps {
  url: string;
  removeImage?: Function;
  index: number;
  height?: number;
  width?: number;
}

const ImageView = ({
  url,
  index,
  removeImage,
  width,
  height,
}: ImageViewProps) => {
  const { openMD } = DialogService();

  const onRemove = () => {
    if (removeImage) {
      removeImage(index);
    }
  };

  const viewDetail = () => {
    openMD("", <ImageDetail imageUrl={url} />, []);
  };

  return (
    <Card
      sx={{
        width: width || "100%",
        height: height || "100%",
        position: "relative",
      }}
    >
      <Box onClick={viewDetail} sx={{ width: "100%", height: "100%" }}>
        <CardMedia
          component="img"
          alt="Image"
          image={url}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>
      {removeImage && (
        <IconButton
          onClick={onRemove}
          aria-label="Remove Image"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Card>
  );
};

export default ImageView;
